import { update as updateProfile } from '../api/profile.js';
import { setAuthState } from './auth.js';

/**
 * Remember the seeker's first AutoApply submit (EN-704): from then on the AutoApply review hides its guidance banner.
 * The cached user takes the flag before the save, so a review opened next reads it at once. Best effort: a failed
 * save only brings the banner back after a reload.
 */
export const markFirstAutoApplySubmitted = async () => {
	const { getUser, setUser } = setAuthState();
	const user = getUser();

	if (!user || user.options?.first_autoapply_submitted) {
		return;
	}

	const options = { ...user.options, first_autoapply_submitted: true };
	setUser({ ...user, options });

	try {
		const response = await updateProfile({ options });
		setUser(response.data.data);
	} catch {
		// The cached flag still hides the banner this session.
	}
};
